import Vue from 'vue';

export default {
    namespaced: true,

    state: () => ({
        orders: [],
        loadProgress: false,
        ordersCount: 0,
        totalPages: 0,
        pageSize: 10,
        page: 0, // номер следующей
    }),

    getters: {
        orders: state => state.orders,
        ordersCount: state => state.ordersCount,
        loadProgress: state => state.loadProgress,
        end: state => state.page >= state.totalPages,
    },

    mutations: {
        appendOrders: (state, orders = []) => {
            state.orders = [...state.orders, ...orders];
        },

        setOrderStatus: (state, orderNumber) => {
            state.orders = state.orders.map(order => {
                if (order.orderNumber === orderNumber) Vue.set(order, 'status', 'cancelled')
                return order;
            });
        },

        setOrdersCount: (state, quantity = 0) => {
            state.ordersCount = quantity;
        },

        setTotalPages: (state) => {
            // в методе нет параметра totalPages, поэтому считаем сами
            state.totalPages = Math.ceil(state.ordersCount / state.pageSize);
        },

        setLoadProgress: (state, loadProgress = true) => {
            state.loadProgress = loadProgress;
        },

        setPage: (state, page = state.page + 1) => {
            state.page = page;
        },
    },

    actions: {
        loadOrders({ state, commit }) {
            if (state.loadProgress) return;
            commit('setLoadProgress');

            return this.$api.getOrders({pageNumber: state.page, pageSize: state.pageSize})
                .then(({orders = [], quantity = 0}) => {
                    commit('setOrdersCount', quantity);
                    commit('setTotalPages');
                    commit('appendOrders', orders);
                    commit('setPage');
                })
                .catch((err) => {
                    throw err;
                })
                .finally(() => {
                    commit('setLoadProgress', false);
                });
        },

        updateOrderStatus({commit}, orderNumber) {
            commit('setOrderStatus', orderNumber);
        }
    }
};
